export default "__VITE_ASSET__9d36a441__"